import { memo, useEffect, useState } from 'react'
import { useAuthContext } from '../../hooks/useAuthContext'
import axios from 'axios'
import { toast } from 'react-toastify'
import { HighlightOff as HighlightOffIcon } from '@mui/icons-material'
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Typography,
  DialogActions,
  Autocomplete,
} from '@mui/material'
import {
  DROPDOWN_DEFAULT_VALUE,
  TOAST_SETTINGS,
  TOAST_SETTINGS_ERROR,
} from '../../utility/constants'
import { formatUserDisplayName } from '../../utility/userName'

const DelegateBox = memo(
  ({
    isDelegateOpen,
    setIsDelegateOpen,
    teamDetails,
    task,
    setTasks,
    tasks,
    processReferenceNumber,
    hideOverallComment = task?.hide_overall_comment === true,
  }) => {
    const [delegateComment, setDelegateComment] = useState('')
    const [selectedDelegateToUser, setSelectedDelegateToUser] = useState(DROPDOWN_DEFAULT_VALUE)
    const { user } = useAuthContext()

    const NODE_BASE_URL = process.env.REACT_APP_NODE_BASE_URL

    let axiosOptions = {}
    if (user) {
      axiosOptions = {
        headers: { Authorization: `Bearer ${user.token}` },
      }
    }

    async function handleSaveDelegate() {
      if (
        (!hideOverallComment && (!delegateComment || delegateComment.trim() === '')) ||
        selectedDelegateToUser === DROPDOWN_DEFAULT_VALUE
      ) {
        if (!hideOverallComment && (!delegateComment || delegateComment.trim() === '')) {
          toast.error('Comments must be entered.', TOAST_SETTINGS_ERROR)
        }

        if (selectedDelegateToUser === DROPDOWN_DEFAULT_VALUE) {
          toast.error('Select a valid user.', TOAST_SETTINGS_ERROR)
        }

        return
      }

      const toastSuccessMsg = 'Task delegated successfully.'
      const payload = {
        process_id: task.process_id,
        delegated_by: user?.id,
        delegated_to: selectedDelegateToUser,
        comments: hideOverallComment ? (delegateComment?.trim() || '.') : delegateComment,
      }

      try {
        const result = await axios.post(
          `${NODE_BASE_URL}/data-entry/delegation`,
          payload,
          axiosOptions
        )

        if (result.data === 'OK') {
          setIsDelegateOpen(false)
          toast.success(toastSuccessMsg, TOAST_SETTINGS)

          let updatedTasks = tasks.filter((t) => t.process_id !== task.process_id)

          setTasks(updatedTasks)
        } else {
          toast.error('Delegation failed.', TOAST_SETTINGS_ERROR)
        }
      } catch (error) {
        console.error('Error:', error)
      }
    }

    const handleSelectedDelegateUser = (e, userId) => {
      if (user?.id != userId?.user_id) {
        setSelectedDelegateToUser(userId?.user_id)
      }
    }

    const updatedTeamDetails = teamDetails.filter((member) => member.user_id !== user.id)

    return (
      <Dialog open={isDelegateOpen} fullWidth maxWidth="md">
        <DialogTitle>
          <Grid container justifyContent="space-between" alignItems="center">
            <Typography variant="h5">{`Delegate ${processReferenceNumber}`}</Typography>
            <IconButton
              align="right"
              onClick={() => {
                setIsDelegateOpen(false)
                setSelectedDelegateToUser(DROPDOWN_DEFAULT_VALUE)
                setDelegateComment('')
              }}
              size="small"
            >
              <HighlightOffIcon />
            </IconButton>
          </Grid>
        </DialogTitle>
        <DialogContent>
          {!hideOverallComment && (
            <TextField
              value={delegateComment}
              fullWidth
              multiline
              size="small"
              variant="outlined"
              color="primary"
              label={'Overall Comment'}
              style={{ marginTop: '.7rem' }}
              minRows={3}
              onChange={(e) => setDelegateComment(e.target.value)}
            />
          )}

          <Autocomplete
            options={updatedTeamDetails.filter((it) =>
              task?.delegation_team_ids?.some((delegationTeamId) =>
                it.team_ids.includes(delegationTeamId)
              )
            )}
            getOptionLabel={(option) =>
              formatUserDisplayName(option)
            }
            fullWidth
            style={{ marginTop: '.5rem' }}
            onChange={(e, newValue) => {
              handleSelectedDelegateUser(e, newValue)
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                color="primary"
                size="small"
                label={'Select User to Delegate Task'}
              />
            )}
          />

          <DialogActions>
            <Button
              autoFocus
              variant="outlined"
              color="primary"
              onClick={() => {
                setIsDelegateOpen(false)
                setSelectedDelegateToUser(DROPDOWN_DEFAULT_VALUE)
                setDelegateComment('')
              }}
            >
              Cancel
            </Button>
            <Button color="info" variant="outlined" onClick={handleSaveDelegate}>
              Delegate
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    )
  }
)
export default DelegateBox
